import React from 'react';
import {Text, Button} from '@wix/wix-ui-tpa/cssVars';
import {Replace} from '@wix/wix-ui-icons-common/on-stage';
import {classes} from './ErrorState.st.css';
import {useLocaleKeys} from '../../../../locale-keys/LocaleKeys';

export enum ErrorStateDataHooks {
  Root = 'ErrorStateDataHooks.Root',
  Title = 'ErrorStateDataHooks.Title',
  Subtitle = 'ErrorStateDataHooks.Subtitle',
  Button = 'ErrorStateDataHooks.Button',
}

interface ErrorStateCta {
  text: string;
  onClick: () => void;
  icon?: React.ReactElement;
}

interface ErrorStateProps {
  title?: string;
  subtitle?: string;
  cta?: ErrorStateCta;
  onClick?: () => void;
}

export const ErrorState: React.FC<ErrorStateProps> = (props: ErrorStateProps) => {
  const {title, subtitle, cta, onClick: onClickProp} = props;
  const localeKeys = useLocaleKeys().checkout.couldntLoadError;

  const onRefreshClick = () => {
    onClickProp?.();
    window.location.reload();
  };

  return (
    <div data-hook={ErrorStateDataHooks.Root} className={classes.root}>
      <Text data-hook={ErrorStateDataHooks.Title} className={classes.title}>
        {title ?? localeKeys.title()}
      </Text>
      <Text data-hook={ErrorStateDataHooks.Subtitle} className={classes.subtitle}>
        {subtitle ?? localeKeys.subtitle()}
      </Text>

      <Button
        data-hook={ErrorStateDataHooks.Button}
        className={classes.button}
        prefixIcon={cta ? cta.icon : <Replace />}
        onClick={cta?.onClick ?? onRefreshClick}>
        {cta?.text ?? localeKeys.cta()}
      </Button>
    </div>
  );
};
